import { dropRight, isNil } from 'lodash';
import { Editor, Path, Transforms } from 'slate';

import { createCorrectAnswer } from '../utils';

export function addCorrectAnswer(editor: any, path: Path, forId: string) {
  const firstPath = [...dropRight(path, 1), 0];
  const [first]: any = Editor.node(editor, firstPath);
  const correctAnswer = createCorrectAnswer({ forId }) as any;

  if (first?.type && isNil(first.forId)) {
    Transforms.setNodes(editor, { forId }, { at: firstPath });
  } else {
    Transforms.insertNodes(editor, correctAnswer, { at: path });
  }
}

export function addCorrectAnswerWithExtraOptions(editor, path, options) {
  const correctAnswer = createCorrectAnswer(options) as any;
  try {
    const [first]: any = Editor.node(editor, path);
    if (first?.type && isNil(first.forId)) {
      Transforms.setNodes(editor, correctAnswer, { at: path });
      return;
    }
    // eslint-disable-next-line no-empty
  } catch (ex) {}
  Transforms.insertNodes(editor, correctAnswer, { at: path });
}
